// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { lighten } from 'polished';

const DialogBodyContainer = styled(({ dense, ...rest }) => <div {...rest} />)`
    background-color: ${(props) => props.theme.colors.background.default};
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: ${(props) => (props.dense ? `0` : `1rem 1.337rem`)};
    color: ${(props) => props.theme.colors.text.default};
    font-family: ${(props) => props.theme.typography.fonts.ui};
    font-size: 0.9337rem;
    font-weight: 400;
    max-height: 80vh;
    overflow: auto;

    &::-webkit-scrollbar {
        background: transparent;
        width: 0.8rem;
    }

    &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 14px 14px transparent;
        border: solid 4px transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: ${lighten(0.6, '#333333')};
        display: block;
        border-radius: 1rem;
        border: 0.2rem solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        -webkit-box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.025);
    }
    &::-webkit-scrollbar-button {
        width: 0;
        height: 0;
        display: none;
    }
    &::-webkit-scrollbar-corner {
        background-color: transparent;
    }
`;

export const DialogBody = ({ ...props }) => {
    const a11yProps = {};

    return <DialogBodyContainer {...a11yProps} {...props} />;
};

DialogBody.propTypes = {
    children: PropTypes.node,
    dense: PropTypes.bool
};

DialogBody.defaultProps = {
    dense: false
};
